// management-frontend/src/components/Customer.js

import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { IMaskInput } from "react-imask";
import apiServices from "../services/apiServices";

const defaultCustomer = {
  name: "",
  cnpj: "",
  contactEmail: "",
  contactPhone: "",
  disabled: false,
};

const sysTypes = [
  {
    id: "OPERVEX",
    name: "Opervex",
  },
  {
    id: "OPERVEXALU",
    name: "Aluguel",
  },
];

const Customer = () => {
  const [customers, setCustomers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [statusSysts, setStatusSysts] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [currentCustomer, setCurrentCustomer] = useState(null);
  const api = new apiServices();

  useEffect(() => {
    fetchCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCustomers = async () => {
    try {
      const data = await api.getAllCustomers();

      setCustomers(data);
    } catch (err) {
      console.error("Erro ao buscar clientes:", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setCurrentCustomer({
      ...currentCustomer,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const body = {
      ...currentCustomer,
      cnpj: currentCustomer.cnpj.replace(/[^\d]+/g, ""),
    };

    const result = await api.createCustomer(body);

    if (result.errors) {
      var messages = "";

      result.errors.forEach((error) => {
        messages += error.message + "\n";
      });

      alert(messages);
      return;
    }

    setShowModal(false);
    setCurrentCustomer(defaultCustomer);
    fetchCustomers();
  };

  const handleEdit = (customer) => {
    setCurrentCustomer(customer);
    setShowModal(true);
  };

  const handleUpdate = async (e) => {
    const body = {
      ...currentCustomer,
      cnpj: currentCustomer.cnpj.replace(/[^\d]+/g, ""),
    };

    e.preventDefault();

    const result = await api.updateCustomer(currentCustomer.id, body);

    if (result.errors) {
      var messages = "";

      result.errors.forEach((error) => {
        messages += error.message + "\n";
      });

      alert(messages);
      return;
    }

    setShowModal(false);
    fetchCustomers();
  };

  const handleDelete = (customer) => {
    setCurrentCustomer(customer);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const data = await api.deleteCustomer(currentCustomer.id);

      setShowDeleteModal(false);
      fetchCustomers();
    } catch (err) {
      console.error("Erro ao excluir cliente:", err);
    }
  };

  const formatCNPJ = (value) => {
    // Remove tudo que não é dígito
    const cleaned = value.replace(/\D/g, "");

    // Aplica a formatação do CNPJ
    return cleaned
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .substring(0, 18); // Limita ao tamanho máximo de um CNPJ formatado
  };

  const getStatus = (row) => {
    //       return { text: "A Vencer", class: "bg-warning text-dark" };

    if (row.disabled) return { text: "Inativo", class: "bg-danger text-white" };
    else return { text: "Ativo", class: "bg-success text-white" };
  };

  const getStatusView = (code) => {
    let _class = "";

    switch (code) {
      case "ACTIVE":
        _class = "bg-success text-white";
        break;
      case "NOT_START_DATE":
      case "NOT_END_DATE":
      case "DUE":
        _class = "bg-danger text-white";
        break;
      case "ABOUT_EXPIRE":
        _class = "bg-warning text-dark";
        break;
      case "INACTIVE":
      case "NOT_SERVICE":
        _class = "bg-secondary text-white";
        break;
      default:
        break;
    }

    return _class;
  };

  const handleOpenStatus = async (cust) => {
    const result = await api.getStatusByCustomer(cust.id);

    setStatusSysts(result);
    setShowStatusModal(true);
  };

  return (
    <div>
      <Navbar />
      <div className="container-fluid mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Clientes</h2>
          <button className="btn btn-success" onClick={() => handleEdit(defaultCustomer)}>
            Adicionar Cliente
          </button>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>Status</th>
              <th>ID</th>
              <th>Nome</th>
              <th className="text-center">CNPJ</th>
              <th className="text-center">Inativo</th>
              <th className="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => {
              const status = getStatus(customer);

              return (
                <tr key={customer.id}>
                  <td>
                    <span className={`badge rounded-pill ${status.class}`}>{status.text}</span>
                  </td>
                  <td>{customer.id}</td>
                  <td>{customer.name}</td>
                  <td className="text-center">{formatCNPJ(customer.cnpj)}</td>
                  <td className="text-center">{customer.disabled ? "Sim" : "Não"}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-success me-2" onClick={() => handleOpenStatus(customer)}>
                      Status
                    </button>
                    <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(customer)}>
                      Editar
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(customer)}>
                      Excluir
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Modal para adicionar novo cliente */}
        {showModal && (
          <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{!currentCustomer.id ? "Adicionar Novo Cliente" : "Editar Cliente"}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <form>
                    {/* Abas */}
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="dados-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#dados"
                          type="button"
                          role="tab"
                          aria-controls="dados"
                          aria-selected="true"
                        >
                          Dados Gerais
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="contato-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#contato"
                          type="button"
                          role="tab"
                          aria-controls="contato"
                          aria-selected="false"
                        >
                          Contato
                        </button>
                      </li>
                    </ul>

                    {/* Conteúdo das Abas */}
                    <div className="tab-content mt-3" id="myTabContent">
                      {/* Aba Dados Gerais */}
                      <div className="tab-pane fade show active" id="dados" role="tabpanel" aria-labelledby="dados-tab">
                        <div className="mb-3">
                          <label className="form-label">Nome</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={currentCustomer.name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">CNPJ</label>
                          <IMaskInput
                            type="text"
                            className="form-control"
                            name="cnpj"
                            placeholder="00.000.000/0000-00"
                            value={currentCustomer.cnpj}
                            onAccept={(value) => {
                              setCurrentCustomer({
                                ...currentCustomer,
                                cnpj: value,
                              });
                            }}
                            mask="00.000.000/0000-00"
                            required
                          />
                        </div>
                        <div className="mb-3 form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="disabled"
                            checked={currentCustomer.disabled}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label">Inativo</label>
                        </div>
                      </div>

                      {/* Aba Contato */}
                      <div className="tab-pane fade" id="contato" role="tabpanel" aria-labelledby="contato-tab">
                        <div className="mb-3">
                          <label className="form-label">Nome do Contato</label>
                          <input
                            type="text"
                            className="form-control"
                            name="contactName"
                            value={currentCustomer.contactName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Email do Contato</label>
                          <input
                            type="email"
                            className="form-control"
                            name="contactEmail"
                            value={currentCustomer.contactEmail}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Telefone do Contato</label>
                          <IMaskInput
                            type="text"
                            className="form-control"
                            name="contactPhone"
                            placeholder="(00) 00000-0000"
                            value={currentCustomer.contactPhone}
                            onAccept={(value) => {
                              setCurrentCustomer({
                                ...currentCustomer,
                                contactPhone: value,
                              });
                            }}
                            mask="(00) 00000-0000"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* Botões */}
                    <div className="d-flex justify-content-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => setShowModal(false)}>
                        Cancelar
                      </button>
                      <button type="button" className="btn btn-success" onClick={!currentCustomer.id ? handleSubmit : handleUpdate}>
                        Salvar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal para confirmar exclusão */}
        {showDeleteModal && currentCustomer && (
          <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirmar Exclusão</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p>
                    Tem certeza que deseja excluir o cliente <strong>{currentCustomer.name}</strong>?
                  </p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                    Cancelar
                  </button>
                  <button type="button" className="btn btn-danger" onClick={confirmDelete}>
                    Confirmar Exclusão
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal para Status */}
        {showStatusModal && (
          <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Status dos Sistemas</h5>
                  <button type="button" className="btn-close" onClick={() => setShowStatusModal(false)}></button>
                </div>
                <div className="modal-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th className="text-center">Tipo do Sistema</th>
                        <th>Nome</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statusSysts.map((status) => {
                        const sysType = sysTypes.find((x) => x.id === status.typeSystem);

                        return (
                          <tr>
                            <td>{status.idSystem}</td>
                            <td className="text-center">{sysType?.name}</td>
                            <td>{status.nameSystem}</td>
                            <td>
                              <span className={`badge rounded-pill ${getStatusView(status.codeStatusSystem)}`}>
                                {status.textStatusSystem}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowStatusModal(false)}>
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Customer;
